import type { AgentTool } from "@earendil-works/pi-agent-core";
import { Type, type TSchema } from "typebox";

interface McpToolDescriptor {
	serverId: string;
	serverLabel: string;
	name: string;
	description?: string;
	inputSchema: unknown;
}

export async function loadMcpTools(scope: "chat" | "cowork" = "chat"): Promise<AgentTool<TSchema>[]> {
	const res = await fetch(`/api/mcp/tools?scope=${scope}`).catch(() => undefined);
	if (!res?.ok) return [];
	const body = (await res.json()) as { tools: McpToolDescriptor[] };
	return body.tools.map((t) => buildTool(t));
}

function buildTool(t: McpToolDescriptor): AgentTool<TSchema> {
	const schema = (t.inputSchema && typeof t.inputSchema === "object" ? t.inputSchema : Type.Object({})) as TSchema;
	return {
		name: `${t.serverId}__${t.name}`,
		label: `${t.serverLabel}: ${t.name}`,
		description: t.description ?? "",
		parameters: schema,
		execute: async (_toolCallId, params) => {
			const res = await fetch("/api/mcp/call", {
				method: "POST",
				headers: { "content-type": "application/json" },
				body: JSON.stringify({ serverId: t.serverId, name: t.name, arguments: params }),
			});
			if (!res.ok) {
				const err = await res.text();
				throw new Error(`mcp_call_failed: ${err}`);
			}
			const body = (await res.json()) as { ok: boolean; result?: { content?: unknown[] }; error?: string };
			if (!body.ok) throw new Error(body.error ?? "mcp_error");
			const content = (body.result?.content as Array<{ type: string; text?: string }> | undefined) ?? [];
			const text = content
				.filter((c) => c.type === "text" && typeof c.text === "string")
				.map((c) => c.text as string)
				.join("\n");
			return {
				content: [{ type: "text", text: text || JSON.stringify(body.result) }],
				details: body.result,
			};
		},
	};
}
